/**
 * CRM Service
 * Lead management API calls
 */

import api from '../lib/api';

export const crmService = {
  // Leads
  async getLeads(params = {}) {
    const response = await api.get('/crm/leads', { params });
    return response.data;
  },

  async getLeadById(id) {
    const response = await api.get(`/crm/leads/${id}`);
    return response.data;
  },

  async createLead(data) {
    const response = await api.post('/crm/leads', data);
    return response.data;
  },

  async updateLead(id, data) {
    const response = await api.put(`/crm/leads/${id}`, data);
    return response.data;
  },

  async deleteLead(id) {
    const response = await api.delete(`/crm/leads/${id}`);
    return response.data;
  },

  // Lead Stage Management
  async moveLead(id, stage) {
    const response = await api.post(`/crm/leads/${id}/move`, { stage });
    return response.data;
  },

  async moveLeadToNext(id) {
    const response = await api.post(`/crm/leads/${id}/next`);
    return response.data;
  },

  async moveLeadToPrevious(id) {
    const response = await api.post(`/crm/leads/${id}/previous`);
    return response.data;
  },

  async markLeadAsLost(id, reason) {
    const data = reason ? { reason } : {};
    const response = await api.post(`/crm/leads/${id}/lost`, data);
    return response.data;
  },

  // Lead Notes
  async addNote(id, content) {
    const response = await api.post(`/crm/leads/${id}/notes`, { content });
    return response.data;
  },

  // Lead Activities
  async getActivities(id) {
    const response = await api.get(`/crm/leads/${id}/activities`);
    return response.data;
  },

  // Lead Assignment
  async assignLead(id, assigneeId) {
    const response = await api.post(`/crm/leads/${id}/assign`, { assigneeId });
    return response.data;
  },

  // Lead Tour Scheduling
  async scheduleTour(id, tourData) {
    const response = await api.post(`/crm/leads/${id}/tour`, tourData);
    return response.data;
  },

  // Reports
  async getFunnelReport(params = {}) {
    const response = await api.get('/crm/reports/funnel', { params });
    return response.data;
  },

  async getSourceAnalytics(params = {}) {
    const response = await api.get('/crm/reports/sources', { params });
    return response.data;
  },

  async getConversionRates(params = {}) {
    const response = await api.get('/crm/reports/conversion-rates', { params });
    return response.data;
  },

  async getPerformanceReport(params = {}) {
    const response = await api.get('/crm/reports/performance', { params });
    return response.data;
  },

  // Bulk Operations
  async bulkImport(leads) {
    const response = await api.post('/crm/leads/bulk/import', { leads });
    return response.data;
  },

  async bulkUpdate(leadIds, updates) {
    const response = await api.post('/crm/leads/bulk/update', { leadIds, updates });
    return response.data;
  },
};
